/* Schritt-Listen am Handy (29.10.2026) – ol.ms[data-ms="stepper"|"stack"], Styles in sushi-dz-steps.css. Nur bis 749 px:
   stepper = ein Schritt sichtbar, Balken + „Schritt x von n“, Zurück/Weiter, Wischen blättert zusätzlich;
   stack = Kartenstapel, die oberste Karte zur Seite wischen (oder „Nächste“), sie wandert nach hinten;
   swipe = Karten nebeneinander zum Wischen mit Punkten (z. B. Bundle-Vergleich). data-ms-start = Startkarte.
   Senkrecht scrollt die Seite weiter (touch-action: pan-y). Am Desktop und ohne Skript bleibt die Liste, wie sie ist.
   Im Theme-Editor zeigt ein angeklickter Schritt-Block seine Karte. */
(() => {
  if (window.__sushiMs) return;
  window.__sushiMs = true;
  const mob = matchMedia('(max-width: 749px)');
  const RM = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const all = [];
  const two = (v) => String(v).padStart(2, '0');

  const init = (ol) => {
    if (ol.__ms) return;
    const mode = ol.dataset.ms;
    const items = [...ol.children].filter((li) => li.tagName === 'LI');
    const n = items.length;
    if ((mode !== 'stack' && mode !== 'stepper' && mode !== 'swipe') || n < 2) return;
    ol.__ms = true;
    const label = ol.dataset.msLabel || 'Schritt';
    let cur = Math.min(n - 1, +ol.dataset.msStart || 0), busy = false;
    if (mode === 'swipe') return swipe(ol, items, label, cur);
    items.forEach((li) => { li.dataset.total = two(n); });

    let top = null, bars = [], meta = null;
    if (mode === 'stepper') {
      top = document.createElement('div');
      top.className = 'ms-top';
      top.innerHTML = `<div class="ms-bar" aria-hidden="true">${'<i></i>'.repeat(n)}</div><p class="ms-meta" aria-live="polite"></p>`;
      ol.before(top);
      bars = [...top.querySelectorAll('i')];
      meta = top.querySelector('.ms-meta');
    }
    const nav = document.createElement('div');
    nav.className = 'ms-nav';
    nav.innerHTML = `<button type="button" class="ms-prev">Zurück</button>${mode === 'stack' ? '<span class="ms-hint" aria-hidden="true">Karte zur Seite wischen</span><span class="visually-hidden" aria-live="polite"></span>' : ''}<button type="button" class="ms-next">${mode === 'stack' ? 'Nächste' : 'Weiter'}</button>`;
    ol.after(nav);
    const prev = nav.querySelector('.ms-prev'), next = nav.querySelector('.ms-next'), live = nav.querySelector('[aria-live]');

    const lay = () => {
      const on = mob.matches;
      ol.classList.toggle('is-ready', on);
      if (top) top.hidden = !on;
      nav.hidden = !on;
      items.forEach((li, i) => {
        if (!on) {
          li.style.transform = li.style.zIndex = li.style.opacity = '';
          li.classList.remove('is-on', 'is-drag');
          li.removeAttribute('aria-hidden');
          return;
        }
        if (mode === 'stack') {
          const d = (i - cur + n) % n;
          li.style.zIndex = String(n - d);
          li.style.transform = d < 3 ? `translateY(${d * 11}px) scale(${1 - d * 0.045})` : 'translateY(22px) scale(.91)';
          li.style.opacity = d < 3 ? '1' : '0';
        }
        li.classList.toggle('is-on', i === cur);
        li.setAttribute('aria-hidden', i === cur ? 'false' : 'true');
      });
      if (!on) return;
      if (mode === 'stepper') {
        bars.forEach((b, k) => b.classList.toggle('on', k <= cur));
        meta.textContent = `${label} ${cur + 1} von ${n}`;
        prev.disabled = cur === 0;
        next.textContent = cur === n - 1 ? 'Von vorn' : 'Weiter';
      } else {
        live.textContent = `${label} ${cur + 1} von ${n}`;
      }
    };
    const go = (i) => { cur = (i + n) % n; lay(); };
    const fly = (dir) => {
      if (busy) return;
      const li = items[cur];
      li.classList.remove('is-drag');
      if (RM) return go(cur + 1);
      busy = true;
      li.style.transform = `translateX(${dir * 130}%) rotate(${dir * 16}deg)`;
      li.style.opacity = '0';
      setTimeout(() => {
        li.style.transition = 'none';
        go(cur + 1);
        void li.offsetWidth;
        li.style.transition = '';
        busy = false;
      }, 280);
    };

    next.addEventListener('click', () => (mode === 'stack' ? fly(-1) : go(cur === n - 1 ? 0 : cur + 1)));
    prev.addEventListener('click', () => go(cur - 1));

    let drag = null;
    ol.addEventListener('pointerdown', (e) => {
      if (!mob.matches || busy || e.target.closest('a,button')) return;
      const li = e.target.closest('li');
      if (!li || li !== items[cur]) return;
      drag = { li, x: e.clientX, dx: 0 };
      try { li.setPointerCapture(e.pointerId); } catch (err) { /* ältere Browser */ }
    });
    ol.addEventListener('pointermove', (e) => {
      if (!drag) return;
      drag.dx = e.clientX - drag.x;
      if (mode === 'stack' && Math.abs(drag.dx) > 4) {
        drag.li.classList.add('is-drag');
        drag.li.style.transform = `translateX(${drag.dx}px) rotate(${drag.dx / 18}deg)`;
      }
    });
    const end = (e) => {
      if (!drag) return;
      const { dx } = drag;
      drag = null;
      const done = e.type === 'pointerup';
      if (mode === 'stack') {
        if (done && Math.abs(dx) > 70) fly(dx < 0 ? -1 : 1);
        else { items[cur].classList.remove('is-drag'); lay(); }
      } else if (done && Math.abs(dx) > 40) {
        go(Math.min(n - 1, Math.max(0, cur + (dx < 0 ? 1 : -1))));
      }
    };
    ol.addEventListener('pointerup', end);
    ol.addEventListener('pointercancel', end);

    ol.classList.add('no-anim');
    lay();
    requestAnimationFrame(() => requestAnimationFrame(() => ol.classList.remove('no-anim')));
    all.push({ items, lay, go });
  };

  /* swipe = Karten nebeneinander (CSS scroll-snap), Punkte darunter zeigen und wählen die Karte; Start bei data-ms-start */
  function swipe(ol, items, label, start) {
    const n = items.length, nav = document.createElement('div');
    nav.className = 'ms-nav ms-dots';
    nav.innerHTML = items.map((_, i) => `<button type="button" aria-label="${label} ${i + 1} von ${n}"></button>`).join('');
    ol.after(nav);
    const dots = [...nav.children];
    const step = () => items[1].offsetLeft - items[0].offsetLeft || ol.clientWidth;
    const mark = () => {
      const i = Math.max(0, Math.min(n - 1, Math.round(ol.scrollLeft / step())));
      dots.forEach((d, k) => { d.classList.toggle('on', k === i); d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    };
    const lay = () => { nav.hidden = !mob.matches; if (mob.matches) mark(); };
    dots.forEach((d, i) => d.addEventListener('click', () => ol.scrollTo({ left: i * step(), behavior: RM ? 'auto' : 'smooth' })));
    let raf = 0;
    ol.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(mark); }, { passive: true });
    lay();
    if (mob.matches && start) ol.scrollLeft = start * step();
    mark();
    all.push({ items, lay, go: (i) => ol.scrollTo({ left: i * step() }) });
  }

  const scan = () => document.querySelectorAll('ol.ms[data-ms]').forEach(init);
  const onChange = () => all.forEach((a) => a.lay());
  if (mob.addEventListener) mob.addEventListener('change', onChange); else mob.addListener(onChange);
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('shopify:block:select', (e) => all.forEach((a) => {
    const i = a.items.indexOf(e.target);
    if (i > -1) a.go(i);
  }));
  scan();
})();
